import React, { Component } from 'react'
import ManageMemberCard from './dashboardComponent/memberManager/ManageMemberCard'
import GrantProjectAccessCard from './dashboardComponent/projectAccess/GrantProjectAccessCard'
import AboutCompanyCard from './dashboardComponent/settings/AboutCompanyCard'
import CompanyQrCodeCard from './dashboardComponent/settings/CompanyQrCodeCard'
import TransferCreatorCredentialsCard from './dashboardComponent/transferCreator/TransferCreatorCredentialsCard'
import Loader from 'react-loader-spinner';
import { connect } from 'react-redux';
import MyPaymentCardDetails from '../landing/pricing/tabbedComponents/MyPaymentCardDetails'
import MyPaymentSettings from '../landing/pricing/tabbedComponents/MyPaymentSettings';
import MyPlacedOrders from '../landing/pricing/tabbedComponents/MyPlacedOrders';
import DashboardLock from '../widgets/DashboardLock'
import MyPlacedConOrders from '../landing/pricing/tabbedComponents/MyPlacedConOrders'
import AllCompanyLimitStats from './dashboardComponent/settings/AllCompanyLimitStats'

class CompanyProfile extends Component {
    constructor(props) {
        super()

        this.state = {
            navPageNum: 0,
        }
    }

    handleNavPage = (navPageNum) => {
        this.setState({
            navPageNum
        })
    }

    render() {
        const { ProductOrder } = this.props;
        // console.log(ProductOrder)
        const selectedSubPageLinkStyle = {
            color: this.props.themeColors.themeHoverColor,
            fontSize: '16px',
            fontWeight: 'bold',
        }
        const subPageLinkStyle = {
            color: this.props.themeColors.darkThemeColor,
            fontSize: '16px',
            fontWeight: 'bold',
        }
        const textStyle = {
            color: this.props.themeColors.darkThemeColor,
        }

        const { userData, companyData, themeColors } = this.props;
        let boughtOrderId = 'boughtSubscription' in companyData ? companyData.boughtSubscription.orderId : null;
        const subscriptionBoughtActive = boughtOrderId ? companyData.boughtSubscription.applied : false
        // console.log(JSON.stringify(companyData.boughtSubscription));

        const showPaymentCardRelatedPages = "stripeCusId" in companyData ? "isStripeSetupComplete" in companyData ? companyData.isStripeSetupComplete ? companyData.stripeCusId === "" ? false : true : false : false : false;
        const listOfProfileSubPages = [<CompanyCards subscriptionBoughtActive={subscriptionBoughtActive} ProductOrder={ProductOrder} companyData={companyData} themeColors={themeColors} />, <MyPaymentCardDetails />, <MyPaymentSettings hasStripeCusId={showPaymentCardRelatedPages} />, <MyPlacedOrders subscriptionBoughtActive={subscriptionBoughtActive} />, <MyPlacedConOrders />]
        const subPage = listOfProfileSubPages[this.state.navPageNum];

        return (
            <div className="container-fluid py-3">
                <div className="">
                    <div className="">
                        <ul className="nav nav-tabs">
                            <li className="nav-item">
                                <a style={this.state.navPageNum === 0 ? selectedSubPageLinkStyle : subPageLinkStyle} className={`nav-link${this.state.navPageNum === 0 ? ' active' : ''}`} href="#!" onClick={() => this.handleNavPage(0)}>Dashboard</a>
                            </li>
                            {showPaymentCardRelatedPages ? <li className="nav-item">
                                <a style={this.state.navPageNum === 1 ? selectedSubPageLinkStyle : subPageLinkStyle} className={`nav-link${this.state.navPageNum === 1 ? ' active' : ''}`} href="#!" onClick={() => this.handleNavPage(1)}>Card details</a>
                            </li> : <React.Fragment />}
                            <li className="nav-item">
                                <a style={this.state.navPageNum === 2 ? selectedSubPageLinkStyle : subPageLinkStyle} className={`nav-link${this.state.navPageNum === 2 ? ' active' : ''}`} href="#!" onClick={() => this.handleNavPage(2)}>{showPaymentCardRelatedPages ? 'Payment settings' : 'Add payment method'}</a>
                            </li>
                            {showPaymentCardRelatedPages ? <li className="nav-item">
                                <a style={this.state.navPageNum === 3 ? selectedSubPageLinkStyle : subPageLinkStyle} className={`nav-link${this.state.navPageNum === 3 ? ' active' : ''}`} href="#!" onClick={() => this.handleNavPage(3)}>Subscriptions</a>
                            </li> : <React.Fragment />}
                            {showPaymentCardRelatedPages ? <li className="nav-item">
                                <a style={this.state.navPageNum === 4 ? selectedSubPageLinkStyle : subPageLinkStyle} className={`nav-link${this.state.navPageNum === 4 ? ' active' : ''}`} href="#!" onClick={() => this.handleNavPage(4)}>Top ups</a>
                            </li> : <React.Fragment />}
                        </ul>
                    </div>
                    <div className="tab-content">
                        <div style={{ backgroundColor: 'white' }} className="p-2">{subPage}</div>
                    </div>
                </div>
            </div>
        )
    }
}

const CompanyCards = (props) => {
    const { subscriptionBoughtActive, ProductOrder, themeColors, companyData } = props;
    // console.log(ProductOrder);
    // console.log(companyData);
    if (subscriptionBoughtActive) {

        if (ProductOrder && companyData) {
            // console.log(ProductOrder)
            const { tagCount, tagLimit, companyMembersLimit } = ProductOrder;
            const { totalActiveCompanyMembers } = companyData;
            const tagLimitReached = tagCount > tagLimit ? true : false;
            // console.log(totalActiveCompanyMembers, companyMembersLimit)
            const companyMemberLimitReached = companyMembersLimit === "-1" ? false : totalActiveCompanyMembers > companyMembersLimit ? true : false;
            // console.log(companyMemberLimitReached)
            // console.log(tagCount,tagLimit);
            if (tagLimitReached) {
                return (
                    <React.Fragment>
                        <DashboardLock isCompanyTagLimitReached={true} />
                    </React.Fragment>
                );
            }
            if (companyMemberLimitReached) {
                return (
                    <div className="container-fluid py-3">
                        <div className="card-deck mb-2 px-2">
                            <AboutCompanyCard />
                            <CompanyQrCodeCard />
                            <ManageMemberCard />
                            <AllCompanyLimitStats tagCount={tagCount} tagLimit={tagLimit} companyMembersLimit={companyMembersLimit} totalActiveCompanyMembers={totalActiveCompanyMembers} />
                        </div>
                    </div>
                );
            }
            else {
                return (
                    <div className="container-fluid py-3">
                        <div className="card-deck mb-2 px-2">
                            <AboutCompanyCard />
                            <ManageMemberCard />
                            <GrantProjectAccessCard />
                        </div>

                        <div className="card-deck mb-2 px-2">
                            <CompanyQrCodeCard />
                            {/* <TransferCreatorCredentialsCard /> */}
                            <AllCompanyLimitStats tagCount={tagCount} tagLimit={tagLimit} companyMembersLimit={companyMembersLimit} totalActiveCompanyMembers={totalActiveCompanyMembers} />
                            {/* <div className="card p-2 " style={{ borderRadius: '15px', border: 'none', backgroundColor: 'transparent' }} ></div> */}

                        </div>

                    </div>
                );
            }
        }
        else {
            return (
                <div className="container-fluid">
                    <div className="" >
                        <div className="card p-3 pt-5">
                            <Loader
                                type="TailSpin"
                                color={themeColors.themeColor}
                                height={50}
                                width={50}
                            />
                            {/* <br></br>
                            <p style={textStyle}>Loading your company...</p>
                            <br></br> */}
                        </div>
                    </div>
                </div>
            )
        }

    }
    else {
        return (
            <React.Fragment>
                <DashboardLock isSubscriptionBoughtActive={false}/>
            </React.Fragment>
        );
    }
};

const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,
        dashboardSidebarSize: state.appControl.dashboardSidebarSize,
        userId: state.firebase.auth.uid,
        userData: state.firebase.profile,
        modalStyles: state.appControl.modalStyles,
        auth: state.auth,
        ProductOrder: state.firestore.data.ProductOrder,
        companyData: state.firestore.data.Company,
    }
}

export default connect(mapStateToProps)(CompanyProfile)